import React from 'react';
import {NodeProps} from 'reactflow';

import {PlaceholderNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

export default function PlaceholderNodeRenderer(props: NodeProps<PlaceholderNodeData>): JSX.Element {
  return <BenchlingNode<never, PlaceholderNodeData> {...props} />;
}
